import * as L from 'leaflet';
import { FrameHistory } from '../models/manager-content-vehicle-history-drawer.model';
import { getSpeedColor } from './create-speed-legend.helper';

export interface SpeedSegmentOptions {
  interactive?: boolean;
  className?: string;
}

export function createSpeedSegments(
  frames: FrameHistory[],
  options?: SpeedSegmentOptions
): L.Polyline[] {
  const defaults: Required<SpeedSegmentOptions> = {
    interactive: false,
    className: 'speed-segment',
  };
  const opts = { ...defaults, ...(options || {}) };

  const speedSegments: L.Polyline[] = [];

  // Crear segmentos de ruta con colores según velocidad
  for (let i = 1; i < frames.length; i++) {
    const prevFrame = frames[i - 1];
    const currentFrame = frames[i];

    // Coordenadas del segmento
    const prevLatLng = L.latLng(
      parseFloat(prevFrame.lat),
      parseFloat(prevFrame.lng)
    );
    const currentLatLng = L.latLng(
      parseFloat(currentFrame.lat),
      parseFloat(currentFrame.lng)
    );

    // Obtener velocidad del frame actual
    const speedKmH = currentFrame.speed || 0;
    const { color, weight } = getSpeedColor(speedKmH);

    // Crear segmento con estilo moderno
    const segment = L.polyline([prevLatLng, currentLatLng], {
      color: color,
      weight: weight,
      opacity: 0.9,
      lineCap: 'round',
      lineJoin: 'round',
      interactive: opts.interactive,
      className: opts.className,
    });

    // Agregar tooltip con información de velocidad
    segment.bindTooltip(
      `
        <div style="
          text-align: center; 
          font-weight: 500; 
          font-family: 'Inter', Arial, sans-serif;
          background: rgba(0, 0, 0, 0.85);
          color: white;
          padding: 8px 12px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          backdrop-filter: blur(8px);
          border: none;
        ">
          <div style="
            color: ${color}; 
            font-size: 12px; 
            margin-bottom: 4px;
            font-weight: 600;
          ">
            🚗 Velocidad
          </div>
          <div style="
            font-size: 14px; 
            font-weight: 600;
            margin-bottom: 2px;
          ">
            ${speedKmH.toFixed(1)} km/h
          </div>
          <div style="
            font-size: 11px; 
            color: #ccc; 
            margin-top: 2px;
            opacity: 0.9;
          ">
            ${getSpeedLabel(speedKmH)}
          </div>
        </div>
      `,
      {
        permanent: false,
        direction: 'top',
        className: 'speed-segment-tooltip',
        offset: [0, -10],
      }
    );

    speedSegments.push(segment);
  }

  return speedSegments;
}

// Función auxiliar para obtener la etiqueta de velocidad
function getSpeedLabel(speedKmH: number): string {
  if (speedKmH <= 30) {
    return 'Velocidad Baja';
  } else if (speedKmH <= 60) {
    return 'Velocidad Media';
  } else {
    return 'Velocidad Alta';
  }
}
